// eslint-disable-next-line import/no-anonymous-default-export
export default {
  1: 'NormasTecnicas',
  2: 'DesenhoPadrao',
};
